import { render } from "./SurveyNotCompleted.vue?vue&type=template&id=08874460&scoped=true"
import script from "./SurveyNotCompleted.vue?vue&type=script&lang=js"
export * from "./SurveyNotCompleted.vue?vue&type=script&lang=js"

import "./SurveyNotCompleted.vue?vue&type=style&index=0&id=08874460&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08874460"

export default script